import { generateUtilityClasses } from '@mui/material';

export const modalBodyClasses = generateUtilityClasses('ModalBody', ['root', 'content']);
